import React, { FC, useEffect } from 'react';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import styled from 'styled-components/native';

import i18n from '@webtrader/core/i18n';
import { authService, useAuth } from '@webtrader/core/services/auth';

import NavigationHeader from '../Header';
import SignUpForm from './Form';

interface IProps {}

const SignUpScreen: FC<IProps> = () => {
  const { navigateToSignUpForm } = useAuth();

  useEffect(() => {
    if (navigateToSignUpForm) {
      authService.resetNavigateToSignUpForm();
    }
  }, [navigateToSignUpForm]);

  return (
    <KeyboardAwareScrollView scrollEnabled={true} enableOnAndroid={true}>
      <Screen>
        <NavigationHeader title={i18n.t('Sign Up')} />
        <SignUpForm />
      </Screen>
    </KeyboardAwareScrollView>
  );
};

export default SignUpScreen;

const Screen = styled.View`
  flex: 1;

  padding-start: ${({ theme }) => theme.sizes.mobile.basePaddingStart}px;
  padding-end: ${({ theme }) => theme.sizes.mobile.basePaddingEnd}px;
`;
